import { Chip } from "@mui/joy";
import { useTranslation } from "react-i18next";
import useMembershipStore, {
  type SubscriptionTier,
} from "../stores/membershipStore";

type PremiumChipProps = {
  size?: "sm" | "md" | "lg";
};

/** Label for `subscription_tier` from GET /api/current-user (synced via membershipStore). */
function tierLabel(
  tier: SubscriptionTier,
  t: (key: string) => string,
): string {
  switch (tier) {
    case "storyteller":
      return t("membership.storyteller.name");
    case "advanced":
      return t("membership.advanced.name");
    case "ultimate":
      return t("membership.legend.name");
    default:
      return t("premiumChip.premium");
  }
}

export function PremiumChip({ size = "md" }: PremiumChipProps) {
  const { t } = useTranslation();
  const subscriptionTier = useMembershipStore((s) => s.subscriptionTier);

  const isSmall = size === "sm";

  return (
    <Chip
      color="warning"
      variant="soft"
      size={size}
      sx={{
        fontSize: isSmall ? "0.65rem" : "0.75rem",
        fontWeight: 600,
        ml: 1,
        px: isSmall ? 0.75 : 1,
        py: isSmall ? 0.25 : 0.35,
      }}
    >
      {tierLabel(subscriptionTier, t)}
    </Chip>
  );
}
